import { CCTFormControlLabel, ContentBox, EverifyIcon, EverifyLabel, Heading2, PackageRadio } from './ClientConfigToolStyles'
import { Grid, RadioGroup } from '@mui/material'
import React, { ChangeEvent } from 'react'
import clientConfigState, { ClientData, Package } from '../atoms/clientConfigState'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import Button from '@mui/material/Button'
import CancelOutlined from '@mui/icons-material/CancelOutlined'
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined'
import LaunchIcon from '@mui/icons-material/Launch'

type PackageAndFeaturesProps = {
  client: ClientData
  packagesArray: Package[]
}

function packageName(client: ClientData, cctPackage: Package) {
  return (
    <Grid alignItems="center" container direction="row" >
      <Grid item md={1.65}><span>{cctPackage.displayName}</span></Grid>
      {client.package === cctPackage.id && (
        <Grid alignItems="center" color={'#00000099'} columnSpacing={0.5} container direction="row" item md={10.35}>
          <Grid item>
            <EverifyIcon>
              {client.everify ? <CheckCircleOutlinedIcon fontSize='medium' /> : <CancelOutlined fontSize='medium' />}
            </EverifyIcon>
          </Grid>
          <Grid item><EverifyLabel>{`E-Verify ${ client.everify ? 'enabled' : 'disabled' } in Tracker`}</EverifyLabel></Grid>
        </Grid>
      )}
    </Grid>
  )
}

function PackageAndFeatures({ client, packagesArray } : PackageAndFeaturesProps) {
  const updateClientState = useSetRecoilState(clientConfigState)
  const clientState = useRecoilValue(clientConfigState)

  const handlePackageChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedPackage = Number(event.target.value)
    updateClientState({
      ...clientState, 
      data: {
        ...clientState.data,
        package: selectedPackage,
      }
    })
  }
  if (!client.enabled) {
    return null
  }
  return (
    <ContentBox borderSize={1} paddingBottom={1.5}  paddingTop={1.5}>
      <Grid 
        container
        direction="column"
        rowSpacing={0.9}
      >
        <Grid item>
          <Heading2>Package & Features</Heading2>
        </Grid>
        {packagesArray.length > 0 && (
          <Grid
            container
            item
          >
            <Grid item md={8}>
              <RadioGroup
                name="package"
                onChange={handlePackageChange}
                value={client.package}
              >
                {
                  packagesArray.map((cctPackage: Package) => (
                    <CCTFormControlLabel
                      control={
                        <PackageRadio checked={client.package === cctPackage.id} />
                      }
                      data-testid={`cct-package-${cctPackage.id}`}
                      disabled={!client.enabled}
                      key={`package-${cctPackage.id}`}
                      label={packageName(client, cctPackage)}
                      value={cctPackage.id}
                    />
                  ))
                }
              </RadioGroup>
            </Grid>
            <Grid item md={4} />
            <Grid item md={8}>
              <Button
                color="primary"
                disabled= {client.trackerClientId ? false : true}
                endIcon={<LaunchIcon />}
                onClick={() => window.open(`${process.env.REACT_APP_TRACKER_I9_URL}/client/setup?clientid=${client.trackerClientId}`, '_blank')}
                sx={{ textTransform: 'none' }}
                variant="outlined"    
              >
            Configure Tracker settings
              </Button>
            </Grid>
            <Grid item md={4} />            
          </Grid>
        )}
      </Grid>
    </ContentBox>
  )
}

export default PackageAndFeatures